import { render } from "./TipTap.vue?vue&type=template&id=60418a1e"
import script from "./TipTap.vue?vue&type=script&lang=js"
export * from "./TipTap.vue?vue&type=script&lang=js"

import "./TipTap.vue?vue&type=style&index=0&id=60418a1e&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__